export enum HttpHeader {
  Authorization = 'Authorization',
  ClientId = 'x-dw-client-id',
  ContentType = 'Content-Type',
}
